import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  GetSelectedIDsFromList,
  getStartOfMonth,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";

function EarningsDashboard() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [IsPorter, setIsPorter] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [isEarning, setIsEarning] = useState(true);
  const [MNVMoverTipAmountID, setMNVMoverTipAmountID] = useState(0);
  const [tippingObject, setTippingObject] = useState<any>({
    EndDate: getEndOfMonth(),
    JobID: "",
    MNVMoverID: 0,
    StartDate: getStartOfMonth(),
    EarningsView: true,
    Total: 0,
  });

  const [movers, setMovers] = useState<any>([]);
  const [moversData, setMoversData] = useState<any>([]);
  const [gridData, setGridData] = useState<any>([]);
  const [EarningsDetails, setEarningsDetails] = useState<any>([]);

  useEffect(() => {
    ClearFilters(false);
    setIsPorter(globalState.IsPorter);
    getDriverJobsWithTipping();
  }, [clearFilters]);

  function ClearFilters(clear: boolean) {
    var l_oToday = new Date();

    setTippingObject((prevState: any) => ({
      ...prevState,
      StartDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth(),
        1,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      EndDate: new Date(
        l_oToday.getFullYear(),
        l_oToday.getMonth() + 1,
        0,
        10,
        0,
        0,
        0
      ).toLocaleDateString("en-CA"),
      JobID: "",
      MNVMoverID: 0,
    }));
    if (clear == true) setClearFilters(!clearFilters);
  }

  function getDriverJobsWithTipping() {
    setIsAnimation(true);
    let object = tippingObject;
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVQuoteAdmin/MNVQuoteGetDriverJobsWithEarnings",
        object
      )
      .then((response) => {
        if (response.status === 200) {
          let l_response = response.data;

          let Total = 0;
          for (var i = 0; i < l_response[0].length; i++) {
            Total += l_response[0][i]["Amount"];
          }
          if (IsPorter) tippingObject.MNVMoverID = globalState.MNVMoverID;

          setGridData(l_response[0]);
          setMovers(l_response[1]);
          setMoversData(l_response[3]);

          setTippingObject((prevState: any) => ({
            ...prevState,
            Total: Total,
          }));
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const MNVQuoteGetMoverEarningDetail = (
    p_intMNVQuoteID: any,
    p_intMNVMoverID: any,
    p_boolIsLocalQuote: any,
    p_intRoleID: any
  ) => {
    let data = {} as any;
    data.MNVQuoteID = p_intMNVQuoteID;
    data.MNVMoverID = p_intMNVMoverID;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetMoverEarningDetail",
        data
      )
      .then((result) => {
        setIsAnimation(false);
        let thisEarningsDetails: any = result.data[0];

        thisEarningsDetails = FilterJsonExactlyMatching(
          thisEarningsDetails,
          "RoleID",
          p_intRoleID
        );

        tippingObject.MoverTotal = 0;

        for (var i = 0; i < thisEarningsDetails.length; i++) {
          if (
            !p_boolIsLocalQuote &&
            thisEarningsDetails[i]["MNVQuoteDetailTypeID"] <= 5
          ) {
            var l_intTotalMinutes = thisEarningsDetails[i]["Quantity"] * 60;
            var l_intTotalHours = Math.floor(l_intTotalMinutes / 60);
            var l_intRemainingMinutes = parseInt(
              (l_intTotalMinutes % 60).toString()
            );

            var l_strHoursText = "hour";
            if (l_intTotalHours > 1) l_strHoursText = "hours";

            var l_strMinutesText = "minute";
            if (l_intRemainingMinutes > 1) l_strMinutesText = "minutes";

            if (l_intTotalHours > 0 && l_intRemainingMinutes > 0)
              thisEarningsDetails[i]["QuantityText"] =
                l_intTotalHours +
                " " +
                l_strHoursText +
                ", " +
                l_intRemainingMinutes +
                " " +
                l_strMinutesText;
            else if (l_intTotalHours > 0)
              thisEarningsDetails[i]["QuantityText"] =
                l_intTotalHours + " " + l_strHoursText;
            else
              thisEarningsDetails[i]["QuantityText"] =
                l_intRemainingMinutes + " " + l_strMinutesText;
          }

          if (thisEarningsDetails[i]["MNVMoverID"] != p_intMNVMoverID) {
            thisEarningsDetails.splice(i, 1);
            i--;
          } else {
            tippingObject.MoverTotal += thisEarningsDetails[i]["Amount"];
          }
        }
        setEarningsDetails(thisEarningsDetails);
        setShowModal(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [rates, setRates] = useState<any[]>([]);

  const MNVMoverRatesGetCompleteGridData = async () => {
    try {
      let obj = {} as any;
      obj.MoverID = AppContext.MNVMoverID;
      setIsAnimation(true);

      const { data } = await axiosAuth.post(
        `${AppContext.APIURL}api/MNVMoverRates/MNVMoverRatesGetCompleteGridDataCustomAdmin`,
        obj
      );
      setRates(data.Data?.[0] ?? []);
      setIsAnimation(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsAnimation(false);
    }
  };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <div className="flex-d justify-btw flex-gap10">
        <div className="flex-da flex-gap10">
          {IsPorter && (
            <div className="flex-d">
              <div className="copy-tab copy-tab2 copy-tab3">
                <a
                  className={`${isEarning ? "selected" : ""}`}
                  onClick={() => setIsEarning(true)}
                >
                  Earnings
                </a>

                <a
                  className={`${!isEarning ? "selected" : ""}`}
                  onClick={() => {
                    setIsEarning(false);
                    MNVMoverRatesGetCompleteGridData();
                  }}
                >
                  Rates
                </a>
              </div>
            </div>
          )}
          {isEarning == true && (
            <div className="flex-da flex-gap10 date-field">
              <div className="field-input">
                <input
                  type="date"
                  title="Service Start Date"
                  placeholder="Lag"
                  value={tippingObject.StartDate}
                  onChange={(e) =>
                    setTippingObject((prevState: any) => ({
                      ...prevState,
                      StartDate: e.target.value,
                    }))
                  }
                  className="input-field"
                />
              </div>
              <div className="field-input date-field">
                <input
                  type="date"
                  title="Service End Date"
                  placeholder="Lag"
                  value={tippingObject.EndDate}
                  onChange={(e) =>
                    setTippingObject((prevState: any) => ({
                      ...prevState,
                      EndDate: e.target.value,
                    }))
                  }
                  className="input-field"
                />
              </div>
              {!IsPorter && (
                <div className="field-input">
                  <select
                    className="input-field"
                    value={tippingObject.MNVMoverID}
                    onChange={(e) =>
                      setTippingObject((prevState: any) => ({
                        ...prevState,
                        MNVMoverID: e.target.value,
                      }))
                    }
                  >
                    <option value={0}>Select Contractor</option>
                    {movers &&
                      movers.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <option value={item.PID}>{item.Name}</option>
                        </React.Fragment>
                      ))}
                  </select>
                </div>
              )}

              <div className="data-boxes">
                <span>
                  Total: £
                  {tippingObject.Total.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>

              <div className="flex-daj btn-start flex-gap10">
                <a
                  onClick={() => ClearFilters(true)}
                  className="btn-primary flex-daj"
                >
                  Clear Filters
                </a>
                <a
                  onClick={() => getDriverJobsWithTipping()}
                  className="btn-primary flex-daj"
                >
                  Filter
                </a>
              </div>
            </div>
          )}
        </div>
        {isEarning == true && (
          <div className="flex-d btn-start flex-gap10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel(
                  "tblmarketingscore",
                  "Earning Dashboard"
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        )}
        {isEarning == false && (
          <div className="flex-daj btn-start gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel("tblmarketingscore", "Rates")
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        )}
      </div>
      {isEarning == true && (
        <div className="flow-auto mt-10">
          <table className="reuse-table" id="tblmarketingscore">
            <thead>
              <tr>
                <th>Date</th>
                {!IsPorter && <th>Contractor Name</th>}
                <th>Role</th>
                <th>Job ID</th>
                <th>Post Codes</th>
                <th>Type</th>
                <th>Total Amount </th>
                <th className="reuse-tdxs"></th>
              </tr>
            </thead>
            <tbody>
              {gridData &&
                gridData.map((Item: any, index: any) => (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>{formateDate(Item.RequestedDate)}</td>
                      {!IsPorter && <td>{Item.MNVMoverName}</td>}
                      <td>{Item.RoleID == 1 ? "Driver" : "Helper"}</td>
                      <td>{Item.JobID}</td>
                      <td>
                        {Item.FromPostalCode} to {Item.ToPostalCode}
                      </td>

                      <td>
                        {Item.IsLocalQuote && <span>Local</span>}
                        {!Item.IsLocalQuote && <span>Long</span>}
                      </td>
                      <td className="text-right">
                        £
                        {Number(Item.Amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>

                      <td className="text-center">
                        <div className="flex-daj gap-10">
                          <a
                            title="Details"
                            onClick={() => {
                              MNVQuoteGetMoverEarningDetail(
                                Item.MNVQuoteID,
                                Item.MNVMoverID,
                                Item.IsLocalQuote,
                                Item.RoleID
                              );
                            }}
                          >
                            <img
                              src="images/info-red.svg"
                              width="18px"
                              height="18px"
                              alt="split"
                            />
                          </a>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {isEarning == false && (
        <>
          <>
            <div className="flow-auto mt-10">
              <table className="reuse-table" id="tblmarketingscore">
                <thead>
                  <tr>
                    <th>Van</th>
                    <th>Type</th>
                    <th>Tier</th>
                    <th className="text-right">DTP / Mile</th>
                    <th className="text-right">PTD / Mile</th>
                    <th className="text-right">DTD / Mile</th>
                    <th className="text-right">Local / Hour</th>
                    <th className="text-right">Long / Hour</th>
                    <th className="text-right">Long / Mile</th>
                    <th className="text-right">Per Stair Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {rates?.map((row, index) => (
                    <tr key={index}>
                      <td>{row.DTDPerHourRateName}</td>
                      <td>{row.PTDPerHourRateName}</td>
                      <td>{row.Name}</td>

                      <td className="text-right">
                        £
                        {Number(row.DTPPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.PTDPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.DTDPerMileRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.LocalMovePerHourRate)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.DTPPerHourRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(
                          row.LoadingUnloadingPerHourRate
                        )?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="text-right">
                        £
                        {Number(row.PerStairRate)?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        </>
      )}

      {showModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner md-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Details</h3>
                <a className="close-help" onClick={() => setShowModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="flow-auto-lg mt-10">
                <table className="reuse-table">
                  <thead>
                    <tr>
                      <th className="reuse-tdxs"></th>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Rate</th>
                      <th className="text-right">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {EarningsDetails.map((Row: any, index: any) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{Row.Name}</td>

                        {!Row.QuantityText && (
                          <td className="text-right">
                            {Number(Row.Quantity)?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        )}

                        {Row.QuantityText && <td>{Row.QuantityText}</td>}

                        <td className="text-right">
                          £
                          {Number(Row.Rate)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>

                        <td className="text-right">
                          £
                          {Number(Row.Amount)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td></td>
                      <td>
                        <b>Total</b>
                      </td>
                      <td></td>
                      <td></td>
                      <td className="text-right">
                        <b>
                          £
                          {Number(tippingObject.MoverTotal)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex-daj gap-10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EarningsDashboard;
